'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import CodeSplitEnvWrapper from 'pricing-pages-unified-ui/components/CodeSplitEnvWrapper';

const ContactsMaxLimitContainer = props => {
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import(
    /* webpackChunkName: "authed-chunk" */
    `pricing-pages-unified-ui/components/common/info-box/AuthContactLimitBox`),
    publicComponentLoader: () => import(
    /* webpackChunkName: "public-chunk" */
    `pricing-pages-unified-ui/components/common/info-box/PublicContactLimitBox`),
    authedComponentProps: props,
    publicComponentProps: props
  });
};

export default ContactsMaxLimitContainer;